<template>
  <div class="map-wrap" data-tutorial="map">
    <div ref="mapEl" class="map"></div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue"

const props = defineProps({
  // Your existing style (default)
  styleUrl: {
    type: String,
    default: "mapbox://styles/robstev0/clpdicfo2003q01r76ihx4acu"
  },

  // Initial view
  center: { type: Array, default: () => [151.2093, -33.8688] }, // Sydney
  zoom: { type: Number, default: 11 },
  bearing: { type: Number, default: 0 },
  pitch: { type: Number, default: 0 },

  // Controls
  showNavigation: { type: Boolean, default: true }
})

const emit = defineEmits(["loaded"])

const mapEl = ref(null)
let map = null

onMounted(async () => {
  const token = import.meta.env.VITE_MAPBOX_TOKEN

  if (!token) {
    console.error(
      "Mapbox token missing. Set VITE_MAPBOX_TOKEN in your .env file."
    )
    return
  }

  const [{ default: mapboxgl }] = await Promise.all([
    import("mapbox-gl"),
    import("mapbox-gl/dist/mapbox-gl.css"),
  ])

  mapboxgl.accessToken = token

  map = new mapboxgl.Map({
    container: mapEl.value,
    style: props.styleUrl,
    center: props.center,
    zoom: props.zoom,
    bearing: props.bearing,
    pitch: props.pitch,
    preserveDrawingBuffer: true,   // required for canvas.toDataURL() in PDF export
  })

  if (props.showNavigation) {
    map.addControl(new mapboxgl.NavigationControl(), "top-right")
  }

  map.on("load", () => {
    emit("loaded", map)
  })
})

onBeforeUnmount(() => {
  if (map) {
    map.remove()
    map = null
  }
})
</script>

<style scoped>
.map-wrap {
  width: 100%;
  height: 100%;
  min-height: 400px;
}

.map {
  width: 100%;
  height: 100%;
}
</style>
